export { toDollars } from './toDollars';
export { default as calculateDatesRange } from './calculateDatesRange';
export { createAction } from './createAction';
export const variableToString = (varObj) => Object.keys(varObj)[0];
export const createArray = (length = 0) => Array.from({ length: length }, (_, i) => i + 1);
export const isObject = (item) => item && typeof item === 'object' && !Array.isArray(item);
export const deepMerge = (target, source) => {
    const output = { ...target };
    if (isObject(target) && isObject(source)) {
        Object.keys(source).forEach((key) => {
            if (isObject(source[key])) {
                if (!(key in target))
                    Object.assign(output, { [key]: source[key] });
                else
                    output[key] = deepMerge(target[key], source[key]);
            }
            else {
                Object.assign(output, { [key]: source[key] });
            }
        });
    }
    return output;
};
export const filterEnabledItems = (items) => items.filter((item) => item.enabled);
export const convertToEnglishWordList = (list) => {
    if (!list || list.length === 0)
        return '';
    if (list.length === 1)
        return list[0];
    if (list.length === 2)
        return list.join(' and ');
    return list.slice(0, -1).join(', ') + ', and ' + list.slice(-1);
};
export const buildLink = (...segments) => {
    return '/' + segments.filter(Boolean).join('/');
};
